export default __webpack_public_path__ + "static/media/capitalOne.c4dd2a9e.png";